import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiDeleteUser, ApiDeleteUserCompany, ApiGetCompanyAccessDropdown, ApiGetUserById, ApiGetUserCompanyList, ApiInsertUserCompany, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import TrashIcon from "assets/icon/TrashIcon";

export default function UserForm(){
    let navigate = useNavigate()

    const { fetch: registerUser } = useFetch(ApiRegister)
    const { fetch: updateUser } = useFetch(ApiUpdateUser)
    const { fetch: getUserById } = useFetch(ApiGetUserById)
    const { fetch: deleteUser } = useFetch(ApiDeleteUser)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)
    const { fetch: getCompany } = useFetch(ApiGetCompanyAccessDropdown)
    const { fetch: insertUserCompany } = useFetch(ApiInsertUserCompany)
    const { fetch: deleteUserCompany } = useFetch(ApiDeleteUserCompany)
    const { fetch: getUserCompanyList, data: userCompanyList } = useFetch(ApiGetUserCompanyList)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    
    const [userId, setUserId] = useState(EmptyString)
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [email, setEmail] = useState(EmptyString)    
    const [password, setPassword] = useState(EmptyString)    
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [company, setCompany] = useState(EmptyString)
    const [companyOptions, setCompanyOptions] = useState([])

    const [errorUserId, setErrorUserId] = useState(false)
    const [errorUsername, setErrorUsername] = useState(false)
    const [errorName, setErrorName] = useState(false)
    const [errorEmail, setErrorEmail] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    const usernameChange = (e) => { setUsername(e.target.value) }
    const nameChange = (e) => { setName(e.target.value) }
    const emailChange = (e) => { setEmail(e.target.value) }
    const passwordChange = (e) => { setPassword(e.target.value) }
    const confirmPasswordChange = (e) => { setConfirmPassword(e.target.value) }
    const isAdminChange = (e) => { setIsAdmin(!isAdmin) }

    const saveBtnClick = () => {
        if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fInsertUser().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateUser().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})
            
            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteUser(paramUserId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate("/user-setting")
    }
    const addCompanyBtnClick = () => {
        setLoading({isOpen: true})

        fInsertUserCompany().then(() => {
            fGetCompany().then(() => {
                fGetUserCompanyList().then(() => {
                    setLoading({isOpen: false})
                })
            })
        })
    }
    const deleteCompanyBtnClick = (companyId) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteUserCompany(companyId).then(() => {
                fGetUserCompanyList().then(() => {
                    fGetCompany().then(() => {
                        setLoading({isOpen: false})
                    })
                })
            })
        }}})
    }

    useEffect(() => {
        fCheckIsAdmin()

        if (formType === FormTypeEdit){
            setLoading({isOpen: true})

            fGetUserById(paramUserId).then(() => {
                fGetCompany().then(() => {
                    fGetUserCompanyList().then(() => {
                        setLoading({isOpen: false})
                    })                    
                })                
            })
        }
    }, [])

    // Function Api Call
    async function fInsertUser(){
        await registerUser({
            data: {
                username: username,
                name: name,
                email: email,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateUser(){
        await updateUser({
            data: {
                userId: paramUserId,
                username: username,
                name: name,
                email: email,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteUser(userId, status){
        await deleteUser({
            data: {
                userId: userId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/user-setting")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetUserById(paramUserId){
        await getUserById({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                setUserId(data.userId)
                setUsername(data.username)
                setName(data.name)
                setEmail(data.email)
                setIsAdmin(data.isAdmin)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    } 
    async function fGetCompany(){
        await getCompany({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].companyName, value: String(response.data[i].companyId) })
                }

                setCompanyOptions(tempArray)
                if (tempArray.length > 0){
                    setCompany(tempArray[0].value)
                }else{
                    setCompany("")
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }   
    async function fGetUserCompany(){
        await getCompany({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].companyName, value: String(response.data[i].companyId) })
                }

                setCompanyOptions(tempArray)
                setCompany(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }   
    async function fInsertUserCompany(){
        await insertUserCompany({
            data: {
                userId: userId,
                companyId: company
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetUserCompanyList(){
        await getUserCompanyList({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // let tempArray = []

                // for (let i = 0; i < response.data.length; i++){
                //     tempArray.push({ label: response.data[i].companyName, value: String(response.data[i].companyId) })
                // }

                // setCompanyOptions(tempArray)
                // setCompany(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }   
    async function fDeleteUserCompany(companyId){
        await deleteUserCompany({
            data: {
                userId: userId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                // setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (formType === FormTypeEdit){
            if (userId === EmptyString || userId === null){
                setErrorUserId(true)
                errorCount++
            }else{
                setErrorUserId(false)
            }
        }

        if (username === EmptyString || username === null){
            setErrorUsername(true)
            errorCount++
        }else{
            setErrorUsername(false)
        }

        if (name === EmptyString || name === null){
            setErrorName(true)
            errorCount++
        }else{
            setErrorName(false)
        }

        if (email === EmptyString || email === null){
            setErrorEmail(true)
            errorCount++
        }else{
            setErrorEmail(false)
        }

        if (password === EmptyString || password === null){
            setErrorPassword(true)
            errorCount++
        }else{
            setErrorPassword(false)
        }

        if (confirmPassword === EmptyString || confirmPassword === null){
            setErrorConfirmPasswordMessage("Confirm Password is required")
            setErrorConfirmPassword(true)
            errorCount++
        }else{
            setErrorConfirmPassword(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }
    function fCompanyClick(compName, compId){
        navigate("/user-setting/user-access?user=" + name + "&userId=" + paramUserId + "&companyName=" + compName + "&companyId=" + compId)
    }

    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">User Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* User Id */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>User Id</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ userId } onChange={(e) => { setUserId(e.target.value) }} disabled={ true } />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorUserId ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">User Id is required!</span>
                    </div>
                </div>

                {/* Username */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Username</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ username } onChange={usernameChange} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errorUsername ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Username is required!</span>
                    </div>
                </div>

                {/* Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={name} onChange={nameChange} maxLength={30} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Name is required!</span>
                    </div>
                </div>

                {/* Email */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Email</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ email } onChange={emailChange} maxLength={50} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorEmail ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Email is required!</span>
                    </div>
                </div>

                {/* Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={ password } onChange={passwordChange} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Password is required!</span>
                    </div>
                </div>

                {/* Confirm Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Confirm Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={ confirmPassword } onChange={confirmPasswordChange} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorConfirmPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{ errorConfirmPasswordMessage }</span>
                    </div>
                </div>

                {/* Admin */}
                <div>
                    <div className="flex items-center">
                        <div className="w-48">
                            <span>Admin</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72 flex items-center">
                            <input type="checkbox" className="" value={isAdmin} onChange={isAdminChange} checked={isAdmin} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            <div className={`w-full ${ userId === EmptyString ? 'hidden' : 'block' }`}>
                <div className="mt-5">
                    <span className="font-semibold text-xl">Company Access</span>
                </div>
                <hr />

                <div className="flex items-center gap-4 mt-4 w-full">
                    <div className="flex items-center">
                        <div className="w-48">
                            <span>Company</span>
                        </div>
                        <div className="px-2">
                            <span>:</span>
                        </div>
                        <div className="w-72">
                            <Dropdown options={companyOptions} value={company} onChange={(e) => {setCompany(e.value)}} />
                        </div>
                    </div>
                    
                    <div>
                        <AddButton onClick={addCompanyBtnClick} />
                    </div>
                </div>

                <div className="mt-4">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                {/* <th className="font-semibold w-16">No</th> */}
                                <th className="font-semibold text-left px-2">Company</th>
                                <th className="font-semibold w-auto sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            { userCompanyList?.data?.userCompany?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100 cursor-pointer" key={ i }>
                                        {/* <td className="text-center">{ data.rowNumber }</td> */}
                                        <td className="px-2" onClick={() => { fCompanyClick(data.companyName, data.companyId) }}>
                                            {/* <button value={data.companyName} onClick={() => { fCompanyClick(data.companyName, data.companyId) }}>
                                                { data.companyName }
                                            </button> */}
                                            <span>{ data.companyName }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            {/* <button className="button flex gap-2" onClick={() => fEditBtnClick( data.id )}>
                                                <EditIcon className="w-4 fill-white" />
                                            </button> */}
                                            <button className="button flex gap-2" onClick={() => {deleteCompanyBtnClick(data.companyId)}}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            

            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}